import { AppTheme } from './AppTheme';

export const primaryColorMap: Record<string, string> = {
  'cerulean-dark': '#7688c9',
  'cerulean-light': 'rgb(95, 128, 233)',
  'blue-dark': '#587DF1',
  'blue-light': '#587DF1',
  'blue2-dark': '#009cc7',
  'blue2-light': '#00c3ee',
  'purple-dark': '#8276C9',
  'purple-light': '#9373EE',
  'green-dark': '#029e74',
  'green-light': '#039e74',
  'red-dark': '#FD6874',
  'red-light': '#FD6874',
  'orange-dark': '#ffa940',
  'orange-light': '#fa8c16',
  'pink-dark': '#E86CA4',
  'pink-light': '#E86CA4',
  'gold-dark': '#b59a6d',
  'gold-light': '#9a7d56',
  'silver-dark': '#c3b7a4',
  'silver-light': '#8e8374',
};

export const defaultPrimaryColorSet = new Set(
  Object.keys(primaryColorMap).map((x) => x.split('-')[0] ?? ''),
);

export const defaultAccentColor = 'purple';

export const backgroundColorMap: Record<AppTheme.Light | AppTheme.Dark, Record<string, string>> = {
  [AppTheme.Light]: {
    light1: '#ffffff',
    light2: '#f8f8f7',
    light3: '#fdfdf7',
  },
  [AppTheme.Dark]: {
    dark1: '#1a1922',
    dark2: '#22272d',
    dark3: '#252525',
  },
};

export const defaultLightBackgroundColorValue = '#ffffff';
export const defaultDarkBackgroundColorValue = '#1a1922';
